// extracted by mini-css-extract-plugin
export default {"outer":"Header_outer__WrtRJ","nav":"Header_nav__k7G6m","navBrand":"Header_navBrand__mm78y","toggle":"Header_toggle__MmILG"};